import { Component, Input } from '@angular/core';
import { ProjectAccessRoles } from '@completion/models';

export interface UserAvatarData {
  name?: string | null;
  email?: string | null;
  sapId?: string | null;
  role?: ProjectAccessRoles | string | null;
}

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
  standalone: false,
})
export class UserAvatarComponent {
  @Input() user: UserAvatarData | null = null;

  get initials(): string {
    const source = this.user?.name || this.user?.email || this.user?.sapId || '';
    return source ? source.charAt(0).toUpperCase() : '?';
  }

  get displayName(): string {
    return this.user?.name || this.user?.email || this.user?.sapId || '';
  }

  get displayEmail(): string | null {
    return this.user?.email || null;
  }

  get displaySapId(): string | null {
    return this.user?.sapId || null;
  }

  /**
   * Map role to avatar color CSS class.
   * ADMIN = GREEN
   * EDITOR = LIGHTER GREEN
   * OPERATOR_CP = DARK BLUE
   * OPERATOR_MC/OPERATOR_MCP = LIGHTER BLUE
   * COMPANY_SIGN_CERT = PURPLE
   * VENDOR = TEAL
   * READ_ONLY / default = GREY
   */
  get avatarClass(): string {
    const roleKey = (this.user?.role || '').toString().toUpperCase();
    switch (roleKey) {
      case 'ADMIN':
        return 'avatar-admin';
      case 'EDITOR':
        return 'avatar-editor';
      case 'OPERATOR_CP':
        return 'avatar-operator-cp';
      case 'OPERATOR_MC':
      case 'OPERATOR_MCP':
        return 'avatar-operator-mc';
      case 'COMPANY_SIGN_CERT':
        return 'avatar-company-sign-cert';
      case 'VENDOR':
        return 'avatar-vendor';
      case 'READ_ONLY':
        return 'avatar-read-only';
      default:
        return 'avatar-read-only';
    }
  }
}
